import { Logger } from './logger';

const pocket: Record<string, any> = {};

export function getDataFromPocket<T>(key: string, throwIfAbsent = true): T | null {
    if (key in pocket) return pocket[key];

    try {
        const node = document.getElementById(`pocket-${key}`);
        if (!node) {
            if (throwIfAbsent) {
                throw new Error(`Failed to get data from Pocket: ${key}`);
            }
            return null;
        }
        pocket[key] = JSON.parse(node.innerText);
    } catch (e) {
        Logger.error('Failed to get data from Pocket', key, e);
        pocket[key] = null;
    }

    return pocket[key] as T;
}

export function setDataToPocket(key: string, value: unknown) {
    try {
        const nodeId = `pocket-${key}`;

        let node = document.getElementById(nodeId) as HTMLScriptElement;
        if (!node) {
            node = document.createElement('script');
            node.id = nodeId;
            node.type = 'text/json';
            document.head.appendChild(node);
        }

        node.innerText = JSON.stringify(value);
    } catch (e) {
        Logger.error('Failed to set data to Pocket', key, e);
    }
}
